/**
 *	orange-money-shops.conf.js
 */

import orangeMoneyShopsTpl from './orange-money-shops.tpl.html!text';
import OrangeMoneyShopsCtrl from './orange-money-shops.ctrl.js';

let orangeMoneyShopsConf = function($stateProvider) {
    $stateProvider.state('orange-money-shops', {
		url: '/orange-money',
        template: orangeMoneyShopsTpl,
        controllerAs: 'ctrl',
        controller: 'OrangeMoneyShopsCtrl'
	});
};

orangeMoneyShopsConf.$inject = ['$stateProvider'];

export default angular.module('orangeMoneyShops', [])
	.controller('OrangeMoneyShopsCtrl', OrangeMoneyShopsCtrl)
	.config(orangeMoneyShopsConf)
	.name;